<template>
 <div  v-if="figureVisible">
  <el-dialog
    :append-to-body ="true"
    custom-class="figureDialog"
    :close-on-click-modal="false"
    :title="title"
    :visible.sync="figureVisible"
    width="500px"
  >
    <div class="dialogtype" v-show="dialogtype == 1">存在以下同图的售后单/补偿单,请确认是否要提交:</div>
    <el-table  :data="tableData" :span-method="objectSpanMethod" border style="width: 100%">
      <el-table-column prop="imageUrl" label="图片" width="100" align="center">
        <template slot-scope="scope">
          <div class="img-wrapper" >
            <img :src="scope.row.imageUrl" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="afterTypeName" label="单号类型" align="center"> </el-table-column>
      <el-table-column prop="afterId" label="单号" align="center">
        <template slot-scope="scope">
          <el-button   @click="$emit('cellClick', Object.assign(scope.row,{ verson : 2}))" v-show="scope.row.afterType == 2" type="text">{{
            scope.row.afterId
          }}</el-button>
          <span v-show="scope.row.afterType == 1">{{ scope.row.afterId }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="dialogtype==1" @click="figureVisible=false">取消</el-button>
      <el-button @click="handleSave" type="primary">确认</el-button>
    </div>
  </el-dialog>
  </div>
</template>
<script>
import * as http from './compensate.service'

export default {
  props: {
    dialogtype: Number, // 1:提交情况弹窗  2:查看详情弹窗
    title: String,
    imgRiskList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      figureVisible: false,
      tableData: [],
      indexArr: []
    }
  },
  mounted() {
    // this.rowspan()
  },
  methods: {
    init() {
      this.figureVisible = true
    },
    // 获取同图数据
    getData(params) {
      this.tableData = []
      this.indexArr = []
      this.figureVisible = false
      if (this.imgRiskList && this.imgRiskList.length) {
        this.tableData = this.imgRiskList
        this.rowspan()
        this.init()
        return
      }
      http.getImgRisk(params).subscribe((res) => {
        // 如果有返回则弹窗,没有就不用弹窗提示
        if (res.data && res.data.length) {
          this.tableData = res.data
          this.rowspan()
          this.init()
        } else {
          this.figureVisible = false
          this.$emit('handleSave')
        }
      })
    },
    objectSpanMethod({
      row, column, rowIndex, columnIndex 
    }) {
      if (columnIndex === 0) {
        for (let i = 0; i < this.indexArr.length; i += 1) {
          const element = this.indexArr[i]
          for (let j = 0; j < element.length; j += 1) {
            const item = element[j]
            if (rowIndex === item) {
              if (j === 0) {
                return { rowspan: element.length, colspan: 1 }
              }
              return { rowspan: 0, colspan: 0 }
            }
          }
        }
      }
    },
    // 跟进表格的数据合并列
    rowspan() {
      const dataObj = {}
      this.tableData.forEach((item, index) => {
        item.rowIndex = index
        if (dataObj[item.md5]) {
          dataObj[item.md5].push(index)
        } else {
          dataObj[item.md5] = []
          dataObj[item.md5].push(index)
        }
      })
      Object.keys(dataObj).forEach((key) => {
        if (dataObj[key].length > 1) {
          this.indexArr.push(dataObj[key])
        }
      })
    },
    // 确认
    handleSave() { 
      if (this.dialogtype === 3) {
        this.figureVisible = false
        return
      }
      this.$emit('handleSave') 
      this.figureVisible = false
    }
  },
  destroyed() {
    this.figureVisible = false
  },
  activated() {
    this.figureVisible = false
  }
}
</script>
<style lang="less">
.figureDialog {
  .dialogtype {
    margin-bottom: 10px;
  }
  .img-wrapper {
    text-align: center;
    img {
     width: 80px;
     height: 80px;
     border-radius: 6px;
    }
  }
  .el-dialog__header {
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    line-height: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 44px;
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 20px;
    max-height: 60vh;
    overflow-y: scroll;
  }
  .el-dialog__footer {
    padding: 20px;
    .dialog-footer {
      text-align: right !important;
    }
  }
}
</style>
